module.exports = __webpack_public_path__ + "img/bigbasket.1969dbfc.png";